import flatten from 'lodash/flatten'; // eslint-disable-line

const byId = (state = { isFetching: false }, action) => {
  switch (action.type) {
    case 'REQUEST_RELATED': // eslint-disable-line no-case-declarations
      return { ...state, isFetching: true };
    case 'RECIEVE_RELATED': // eslint-disable-line no-case-declarations
      const { response } = action;
      const all = {};
      response.forEach((item) => {
        item.data.forEach(({ id, ...rest }) => {
          all[id] = { ...rest, id };
        });
      });
      return { ...state, ...all, isFetching: false };
    default:
      return state;
  }
};

export default byId;

export const getRelated = (state, contentId) => state[contentId];



// WEBPACK FOOTER //
// ./js/reducers/related/byId.js